import React from "react";
import "../styles/homepage.css";

const FinalCTASection = () => {
  return (
    <section className="final-cta">
      <h3>Explore Your First AI Agent</h3>
      <p>Don’t just watch the market. Ask it, learn from it, and act smarter — with FinTorro AI.</p>
      <a href="/agent-access" className="cta-button">Try AI Agents Now</a>
    </section>
  );
};

export default FinalCTASection;